module.exports = __webpack_public_path__ + "static/media/logo2.59926b70.png";